import { AddressType } from "../types/addressType";
import { AgentType } from "../types/agentType";

export const formatAddress = (address: AddressType | AgentType) => {
  let addressStr;
  if ("address_1" in address && address.address_1) {
    addressStr = `${address.address_1 ? address.address_1 : ""} ${
      address.address_2 ? address.address_2 : ""
    }, ${address.city ? address.city : ""}, ${
      address.province ? address.province : ""
    } ${address.postal_code ? address.postal_code : ""}`;
  } else {
    addressStr = `${address.lot ? address.lot : ""} ${
      address.unit_number ? address.unit_number : ""
    } ${address.street_number ? address.street_number : ""} ${
      address.street_name ? address.street_name : ""
    }, ${address.city ? address.city : ""}, ${
      address.province ? address.province : ""
    } ${address.postal_code ? address.postal_code : ""}`;
  }
  if (addressStr.replace(/\s/g, "") === ",,") return "-";
  return addressStr;
};
